import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./customer_account_usage.js";
//#region src/customer_account_usage_helper.ts
var customer_account_usage_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(usage) {
	switch (usage) {
		case 0: return "Guest checkout only";
		case 1: return "Guest checkout and customer accounts";
	}
}
//#endregion
export { customer_account_usage_helper_exports, name };

//# sourceMappingURL=customer_account_usage_helper.js.map